import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import {
  CoinflowCardValidationResponse,
  doInitializeCvvOnlyTokenExIframe,
  doInitializeTokenExCardOnlyIframe,
  doInitializeTokenExIframe,
  setTokenExScriptTag,
  TokenExIframe,
  CoinflowEnvs,
} from '../lib/common';

@Component
export default class UseCardFormIframe extends Vue {
  @Prop({ type: String, required: true }) env!: CoinflowEnvs;

  loaded = false;
  tokenExScriptLoaded = false;
  tokenExIframe: TokenExIframe | undefined = undefined;
  cachedToken: string | undefined = undefined;

  mounted() {
    setTokenExScriptTag({
      env: this.env,
      setTokenExScriptLoaded: () => {
        this.tokenExScriptLoaded = true;
      },
    });
  }

  destroyed() {
    this.tokenExIframe?.remove();
  }

  setCachedToken(newToken: string | undefined) {
    this.cachedToken = newToken;
  }

  @Emit('loaded')
  setLoaded(loaded: boolean) {
    this.loaded = loaded;
  }

  @Emit('iframeSet')
  setTokenExIframe(iframe: TokenExIframe | undefined) {
    this.tokenExIframe = iframe;
    this.tokenExIframe?.on('validate', this.onValidate);
    this.tokenExIframe?.on('blur', this.onBlur);
    this.tokenExIframe?.on('cvvBlur', this.onCvvBlur);
  }

  @Emit('blur')
  onBlur() {}

  @Emit('cvvBlur')
  onCvvBlur() {}

  @Emit('validate')
  validate() {
    return new Promise<CoinflowCardValidationResponse>((resolve, reject) => {
      this.tokenExIframe?.on(
        'validate',
        (data: CoinflowCardValidationResponse) => {
          resolve(data);
          this.tokenExIframe?.on('validate', this.onValidate);
        },
      );

      this.tokenExIframe?.validate();

      setTimeout(() => {
        resolve({ timeout: true });
        this.tokenExIframe?.on('validate', this.onValidate);
      }, 5000);
    });
  }

  @Emit('validated')
  onValidate(data: any) {}

  async initializeCvvOnlyTokenExIframe(
    args: Omit<
      Parameters<typeof doInitializeCvvOnlyTokenExIframe>[0],
      'env' | 'tokenExScriptLoaded' | 'setCachedToken' | 'setLoaded'
    >,
  ) {
    const iframe = await doInitializeCvvOnlyTokenExIframe({
      ...args,
      tokenExScriptLoaded: this.tokenExScriptLoaded,
      env: this.env,
      setCachedToken: this.setCachedToken,
      setLoaded: this.setLoaded,
    });
    this.setTokenExIframe(iframe);
    return iframe;
  }

  async initializeTokenExIframe(
    args: Omit<
      Parameters<typeof doInitializeTokenExIframe>[0],
      'env' | 'tokenExScriptLoaded' | 'setCachedToken' | 'setLoaded'
    >,
  ) {
    const iframe = await doInitializeTokenExIframe({
      ...args,
      tokenExScriptLoaded: this.tokenExScriptLoaded,
      env: this.env,
      setCachedToken: this.setCachedToken,
      setLoaded: this.setLoaded,
    });
    this.setTokenExIframe(iframe);
    return iframe;
  }

  async initializeTokenExCardOnlyIframe(
    args: Omit<
      Parameters<typeof doInitializeTokenExCardOnlyIframe>[0],
      'env' | 'tokenExScriptLoaded' | 'setCachedToken' | 'setLoaded'
    >,
  ) {
    const iframe = await doInitializeTokenExCardOnlyIframe({
      ...args,
      tokenExScriptLoaded: this.tokenExScriptLoaded,
      env: this.env,
      setCachedToken: this.setCachedToken,
      setLoaded: this.setLoaded,
    });
    this.setTokenExIframe(iframe);
    return iframe;
  }
}
